import { fromJS } from 'immutable';
import { LOAD_TASK_TEMPLATES_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  pagination: {},
  dataset: [],
});

/**
 * Reducer for TaskTemplateTable component
 * @param state
 * @param action
 * @returns {any}
 */
const taskTemplateTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TASK_TEMPLATES_SUCCESS: {
      return state.set('dataset', fromJS(action.values.items.map((template) => template.templateId))).set(
        'pagination',
        fromJS({
          totalCount: action.values._meta.totalCount,
          pageCount: action.values._meta.pageCount,
          currentPage: action.values._meta.currentPage,
          perPage: action.values._meta.perPage,
        }),
      );
    }
    default:
      return state;
  }
};

export default taskTemplateTableReducer;
